import { FC } from "react";
import { withProcedureWraper } from "../../../..";
import { Icon } from "../../../../../../components";
import { useHistory } from "react-router-dom";
import { Routes } from "../../../../../../AppRoutes";
import { ExportProgress, ExportInformation, ExportHistory, ExportList } from "../../components";
import { CreateNotification } from "../../../../../../components/notifier";
import { requestStatus } from "../../../../../../constants";
import { useSelector } from "../../../../../../store/store";
import { Skeleton, Form, Modal, Input } from "antd";
import { useRouteMatch } from "react-router-dom";
import { getUCTDate } from "../../../../../../helper/dateTimeHelper";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getEnv } from "../../../../../../AppConfigs";
import { MailService } from "../../../../../../services/mail/mail.service";
import { mailRegexs } from "../../../../../../constants/mailTemplateConstants";
import { getDDMMYYYFormat } from "../../../../../../helper/dateTimeHelper";
import { getHHmmFormat } from "../../../../../../helper/dateTimeHelper";

import { useEmployee } from "../../../../../../hook";
import { HOChangePersonRequestService } from "../../../../../../services/human-organization/change-person-request.service";
import { StyledButton, StyledTitle } from "../../../../../../components/styled-antd";
import { isNoiBai } from "../../utils";
import { isEnableEdit } from "../../../summary-employee-request/utils";
import { getEmployeeDetail } from "../../../summary-employee-request/utils/get-employee-detail";

export const Detail: FC = withProcedureWraper(() => {
  const [form] = Form.useForm();

  const history = useHistory();
  const { id } = useRouteMatch().params as any;
  const [eRequests, setERequests] = useState<any[]>([]);
  const user = useSelector((state) => state.user);
  const softwares = useSelector((state: any) => state.systemMgmt.softwares);
  const currentUserName = user?.current?.username?.toString().toLowerCase();
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);
  const { data: employees } = useEmployee();

  const { data: detail, isLoading: isLoadingDetailRequest } = useQuery({
    queryKey: ["detail-request-change-person", id],
    queryFn: () => HOChangePersonRequestService.getDetailsChangePersonRequest(id),
    onSuccess: (data) => {
      setERequests(
        data?.fields?.eContent
          ? JSON.parse(data.fields.eContent).map((value: any) => {
              return {
                ...value,
                productName: value?.productName,
                Dram: value.Dram,
                requestedQuantity: value.requestedQuantity,
                approvedQuantity: value?.approvedQuantity,
                inventoryQuantity: value.inventoryQuantity,
                productLifetime: value?.productLifetime,
              };
            })
          : [],
      );
    },
  });

  const approveRequest = async () => {
    if (isNoiBai(detail?.fields?.eDepartment)) {
      try {
        if (getNextStep() === 1) {
          await HOChangePersonRequestService.updateChangePersonRequest(id, {
            eApprovedStatus: requestStatus.approved,
            eApprovedDate: getUCTDate(),
            eRequestStatus: requestStatus.approved,
            eApprovalComment: form.getFieldValue("comment") || "",
          });

          sendMail(
            `${detail?.fields?.eApprovedByITLead}|${
              getEmployeeDetail(detail?.fields?.eApprovedByITLead || "", employees, softwares)?.[0]?.Title
            }`,
            detail,
            "CPRA",
          );
        } else if (getNextStep() === 2) {
          await HOChangePersonRequestService.updateChangePersonRequest(id, {
            eApprovedByITLeadStatus: requestStatus.approved,
            eApprovedByITLeadDate: getUCTDate(),
            eITLeadComment: form.getFieldValue("comment") || "",
            eRequestStatus: requestStatus.completed,
          });

          sendMail(`${detail.createdBy?.user?.email}|${detail.createdBy?.user?.displayName}`, detail, "CPRF");
        }
      } catch (error) {
        CreateNotification({
          title: "Thất bại",
          body: `Duyệt thất bại`,
          icon: "/icons/error.png",
        });
        history.push(Routes.courseStaffPage.path);
      }

      CreateNotification({
        title: "Thành công",
        body: `Đồng ý thành công.`,
        icon: "/icons/success.png",
      });
      history.push(Routes.courseStaffPage.path);
    } else {
      try {
        if (getNextStep() === 1) {
          await HOChangePersonRequestService.updateChangePersonRequest(id, {
            eApprovedStatus: requestStatus.approved,
            eApprovedDate: getUCTDate(),
            eRequestStatus: requestStatus.approved,
            eApprovalComment: form.getFieldValue("comment") || "",
          });

          sendMail(
            `${detail?.fields?.eApprovedByITLead}|${
              getEmployeeDetail(detail?.fields?.eApprovedByITLead || "", employees, softwares)?.[0]?.Title
            }`,
            detail,
            "CPRA",
          );
        } else if (getNextStep() === 2) {
          await HOChangePersonRequestService.updateChangePersonRequest(id, {
            eApprovedByITLeadStatus: requestStatus.approved,
            eApprovedByITLeadDate: getUCTDate(),
            eITLeadComment: form.getFieldValue("comment") || "",
          });

          sendMail(
            `${detail?.fields?.eApprovedByITHead}|${
              getEmployeeDetail(detail?.fields?.eApprovedByITHead || "", employees, softwares)?.[0]?.Title
            }`,
            detail,
            "CPRA",
          );
        } else if (getNextStep() === 3) {
          await HOChangePersonRequestService.updateChangePersonRequest(id, {
            eApprovedByITHeadStatus: requestStatus.approved,
            eApprovedByITHeadDate: getUCTDate(),
            eITHeadComment: form.getFieldValue("comment") || "",
          });
          sendMail(
            `${detail?.fields?.eAssignee}|${
              getEmployeeDetail(detail?.fields?.eAssignee || "", employees, softwares)?.[0]?.Title
            }`,
            detail,
            "CPRA",
          );
        } else if (getNextStep() === 4) {
          await HOChangePersonRequestService.updateChangePersonRequest(id, {
            eAssigneeStatus: requestStatus.approved,
            eAssigneeStatusDate: getUCTDate(),
            eAssigneeComment: form.getFieldValue("comment") || "",
            eRequestStatus: requestStatus.completed,
          });

          sendMail(`${detail.createdBy?.user?.email}|${detail.createdBy?.user?.displayName}`, detail, "CPRF");
        }
      } catch (error) {
        CreateNotification({
          title: "Thất bại",
          body: `Duyệt thất bại`,
          icon: "/icons/error.png",
        });
        history.push(Routes.courseStaffPage.path);
      }

      CreateNotification({
        title: "Thành công",
        body: `Đồng ý thành công.`,
        icon: "/icons/success.png",
      });
      history.push(Routes.courseStaffPage.path);
    }
  };

  const isEnableAccept = () => {
    const nextStep = getNextStep();

    if (detail?.fields?.eRequestStatus === requestStatus.rejected) {
      return false;
    }

    if (detail?.fields?.eRequestStatus === requestStatus.completed) {
      return false;
    }

    if (
      detail?.fields?.eApprovedBy === currentUserName &&
      nextStep === 1 &&
      detail?.fields?.eApprovedStatus === requestStatus.submitted
    ) {
      return true;
    }

    if (
      detail?.fields?.eApprovedByITLead === currentUserName &&
      nextStep === 2 &&
      detail?.fields?.eApprovedByITLeadStatus === requestStatus.submitted
    ) {
      return true;
    }

    if (
      detail?.fields?.eApprovedByITHead === currentUserName &&
      nextStep === 3 &&
      detail?.fields?.eApprovedByITHeadStatus === requestStatus.submitted
    ) {
      return true;
    }

    if (
      detail?.fields?.eAssignee === currentUserName &&
      nextStep === 4 &&
      detail?.fields?.eAssigneeStatus === requestStatus.submitted
    ) {
      return true;
    }

    return false;
  };

  const isEnableRevoke = () => {
    if (detail?.fields?.eRequestStatus === requestStatus.rejected) {
      return false;
    }

    if (detail?.fields?.eRequestStatus === requestStatus.completed) {
      return false;
    }

    const currentStep = getRevokeStep();

    if (currentStep === 1 && detail?.fields?.eApprovedBy === currentUserName) {
      return true;
    }

    if (currentStep === 2 && detail?.fields?.eApprovedByITLead === currentUserName) {
      return true;
    }

    if (currentStep === 3 && detail?.fields?.eApprovedByITHead === currentUserName) {
      return true;
    }

    return false;
  };

  const rejectRequest = async () => {
    if (!form.getFieldValue("comment")) {
      CreateNotification({
        title: "Thất bại",
        body: `Vui lòng nhập lý do từ chối`,
        icon: "/icons/error.png",
      });

      return;
    }

    try {
      if (getNextStep() === 1) {
        await HOChangePersonRequestService.updateChangePersonRequest(id, {
          eRequestStatus: requestStatus.rejected,
          eApprovedStatus: requestStatus.rejected,
          eApprovedDate: getUCTDate(),
          eApprovalComment: form.getFieldValue("comment") || "",
        });
        sendMail(`${detail.createdBy?.user?.email}|${detail.createdBy?.user?.displayName}`, detail, "CPRR");
      } else if (getNextStep() === 2) {
        await HOChangePersonRequestService.updateChangePersonRequest(id, {
          eRequestStatus: requestStatus.rejected,
          eApprovedByITLeadStatus: requestStatus.rejected,
          eApprovedByITLeadDate: getUCTDate(),
          eITLeadComment: form.getFieldValue("comment") || "",
        });
        sendMail(`${detail.createdBy?.user?.email}|${detail.createdBy?.user?.displayName}`, detail, "CPRR");
      } else if (getNextStep() === 3) {
        await HOChangePersonRequestService.updateChangePersonRequest(id, {
          eRequestStatus: requestStatus.rejected,
          eApprovedByITHeadStatus: requestStatus.rejected,
          eApprovedByITHeadDate: getUCTDate(),
          eITHeadComment: form.getFieldValue("comment") || "",
        });
        sendMail(`${detail.createdBy?.user?.email}|${detail.createdBy?.user?.displayName}`, detail, "CPRR");
      } else if (getNextStep() === 4) {
        await HOChangePersonRequestService.updateChangePersonRequest(id, {
          eRequestStatus: requestStatus.rejected,
          eAssigneeStatus: requestStatus.rejected,
          eAssigneeStatusDate: getUCTDate(),
          eAssigneeComment: form.getFieldValue("comment") || "",
        });

        sendMail(`${detail.createdBy?.user?.email}|${detail.createdBy?.user?.displayName}`, detail, "CPRR");
      }
    } catch (error) {
      CreateNotification({
        title: "Thất bại",
        body: `Từ chối thất bại`,
        icon: "/icons/error.png",
      });
      history.push(Routes.courseStaffPage.path);
    }

    CreateNotification({
      title: "Thành công",
      body: `Từ chối thành công.`,
      icon: "/icons/success.png",
    });

    history.push(Routes.courseStaffPage.path);
  };

  const revokeApproval = async () => {
    const currentStep = getRevokeStep();
    try {
      if (currentStep === 1) {
        await HOChangePersonRequestService.updateChangePersonRequest(id, {
          eRequestStatus: requestStatus.submitted,
          eApprovedStatus: requestStatus.submitted,
          eApprovedDate: getUCTDate(),
        });
      } else if (currentStep === 2) {
        await HOChangePersonRequestService.updateChangePersonRequest(id, {
          eRequestStatus: requestStatus.rejected,
          eApprovedByITLeadStatus: requestStatus.rejected,
          eApprovedByITLeadDate: getUCTDate(),
          eITLeadComment: form.getFieldValue("comment") || "",
        });
      } else if (currentStep === 3) {
        await HOChangePersonRequestService.updateChangePersonRequest(id, {
          eRequestStatus: requestStatus.rejected,
          eApprovedByITHeadStatus: requestStatus.rejected,
          eApprovedByITHeadDate: getUCTDate(),
          eITHeadComment: form.getFieldValue("comment") || "",
        });
      }

      CreateNotification({
        title: "Thành công",
        body: `Thu hồi thành công.`,
        icon: "/icons/success.png",
      });

      history.push(Routes.courseStaffPage.path);
    } catch (error) {
      CreateNotification({
        title: "Thất bại",
        body: `Thu hồi thất bại`,
        icon: "/icons/error.png",
      });

      history.push(Routes.courseStaffPage.path);
    }
  };

  const getRevokeStep = () => {
    const nextStep = getNextStep();

    if (detail?.fields?.eRequestStatus === requestStatus.rejected) {
      return 0;
    }

    if (
      detail?.fields?.eApprovedBy === currentUserName &&
      nextStep === 2 &&
      detail?.fields?.eApprovedStatus === requestStatus.approved
    ) {
      return 1;
    }

    if (
      detail?.fields?.eApprovedByITLead === currentUserName &&
      nextStep === 3 &&
      detail?.fields?.eApprovedByITLeadStatus === requestStatus.approved
    ) {
      return 2;
    }

    if (
      detail?.fields?.eApprovedByITHead === currentUserName &&
      nextStep === 4 &&
      detail?.fields?.eApprovedByITHeadStatus === requestStatus.approved
    ) {
      return 3;
    }

    return 0;
  };

  const getNextStep = () => {
    if (detail?.fields?.eRequestStatus === requestStatus.rejected) {
      return -1;
    }

    if (detail?.fields?.eApprovedStatus === requestStatus.submitted) {
      return 1;
    }

    if (detail?.fields?.eApprovedByITLeadStatus === requestStatus.submitted) {
      return 2;
    }

    if (detail?.fields?.eApprovedByITHeadStatus === requestStatus.submitted) {
      return 3;
    }

    if (detail?.fields?.eAssigneeStatus === requestStatus.submitted) {
      return 4;
    }

    return 5;
  };

  if (isLoadingDetailRequest) {
    return <Skeleton />;
  }

  const siteUrl = getEnv("REACT_APP_APPROVER_CHANGE_PERSON");

  const sendMail = async (approver: any, itRepairToolRequest: any, type: string) => {
    const url = siteUrl + "/details/" + itRepairToolRequest.id;
    const arr = approver.split("|");
    let tomail = arr.length > 0 ? arr[0] : "";
    let name = arr.length > 1 ? arr[1] : "";
    const template = mailtemplates.find((m: any) => m.eMailType === type);
    let content = "";

    if (type[3].toLocaleLowerCase() === "r") {
      tomail = itRepairToolRequest.createdBy.user.email;
      name = itRepairToolRequest.createdBy.user.displayName;
    }

    if (type[3].toLowerCase() === "f") {
      content = template.eContent
        .replace(mailRegexs.zero, name)
        .replace(mailRegexs.one, form.getFieldValue("comment") || "");
    } else {
      content = template.eContent
        .replace(mailRegexs.zero + ";", name)
        .replace(mailRegexs.one + ";", "duyệt")
        .replace(mailRegexs.two + ";", itRepairToolRequest?.createdBy?.user?.displayName)
        .replace(
          mailRegexs.three + ";",
          `${getDDMMYYYFormat(itRepairToolRequest.createdDateTime)} - ${getHHmmFormat(
            itRepairToolRequest.createdDateTime,
          )}`,
        )
        .replace(mailRegexs.siteUrl, url);
    }

    const subject = template.eSubject;
    const message = MailService.buildMailMesssage(subject, content, "html", tomail);
    await MailService.sendMail(message);
  };

  const showRejectConfirm = () => {
    Modal.confirm({
      title: <StyledTitle level={5}>Thông báo</StyledTitle>,
      content: (
        <>
          Bạn có chắc chắn muốn từ chối yêu cầu này ?
          <br />
          Vui lòng nhập lý do từ chối
          <br />
          <StyledTitle level={5}>
            Lý do <span className="text-danger ml-1">*</span>{" "}
          </StyledTitle>
          <Input
            onChange={(e: any) => {
              form.setFieldValue("comment", e.target.value);
            }}
          />
        </>
      ),
      okText: "Xác nhận",
      okType: "danger",
      okButtonProps: { type: "primary" },
      cancelText: "Huỷ",
      cancelButtonProps: {
        style: { backgroundColor: "orange", color: "white" },
      },

      onOk() {
        rejectRequest();
      },
      onCancel() {
        form.setFieldValue("comment", null);
      },
    });
  };

  return (
    <div className="ItCodeGrantedDetailPage pd15">
      <div className="PageHead">
        <div className="title">
          <div className="btnBack" onClick={() => history.push(Routes.courseStaffPage.path)}>
            <Icon.ArrowLeft />
          </div>
          Xem Xét Yêu Cầu Duyệt
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12 col-md-12">
          <ExportProgress />
          <ExportInformation />
          <ExportList
            eRequests={eRequests}
            setERequests={setERequests}
            hiddenEdit={getNextStep() === 1 ? false : true}
          />
          <ExportHistory form={form} isEnableAccept={isEnableAccept()} />

          <div className="d-flex justify-content-center">
            {isEnableAccept() && (
              <StyledButton bgColor="green" className="mr-3" type="primary" onClick={approveRequest}>
                Đồng ý
              </StyledButton>
            )}

            {isEnableAccept() && (
              <StyledButton bgColor="red" className="mr-3" onClick={showRejectConfirm} danger type="primary">
                Không đồng ý
              </StyledButton>
            )}

            {!isEnableAccept() && isEnableRevoke() && (
              <StyledButton bgColor="grey" className="mr-3" onClick={revokeApproval}>
                Thu hồi
              </StyledButton>
            )}

            {isEnableEdit(getNextStep(), detail, currentUserName) && (
              <StyledButton
                onClick={() => history.push(Routes.courseStaffCreatePage.path.replace(":id", id))}
                bgColor="orange"
              >
                Chỉnh sửa
              </StyledButton>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});
